var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_title"},[_c('span',{staticClass:"_name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_vm._v(" "),_c('span',{staticClass:"_english"},[_vm._v(" "+_vm._s(_vm.english)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-781960eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Title.vue
// module id = null
// module chunks = 